import { DOCUMENT, Location, PlatformLocation } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { CacheObjectService, DeviceService, EventTrackerService } from '@app/core';
import { ScrollToLastPosition } from '@app/helper/scroll-to-last-position';
import { IndicatorService } from '@app/shared';
import { environment } from '@env/environment';
import { SubscriptionLike } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ArtistsService } from './artists.service';
import { IArtistPage } from './IArtistPage';

@Component({
  selector: 'navaar-artists',
  templateUrl: './artists.component.html',
  styleUrls: ['./artists.component.scss']
})
export class ArtistsComponent extends ScrollToLastPosition implements OnInit, OnDestroy {
  public model: IArtistPage = null;
  public environment = environment;
  public isShowDescription: boolean = false;
  private artistId: { artistTypeApiKey?: string, artistId?: string } = {};
  private page: number = 0;
  private PAGE_SIZE = 15;
  public isEnd = false;
  public isLoading = false;
  public books: Array<any>;
  public id: number;
  private _locationObserve: SubscriptionLike;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly platformLocation: PlatformLocation,
    private readonly location: Location,

    private readonly artistService: ArtistsService,
    private readonly indicator: IndicatorService,
    private readonly render: Renderer2,
    private readonly router: ActivatedRoute,
    private readonly chkd: ChangeDetectorRef,
    private readonly route: Router,
    private readonly eventTracker: EventTrackerService,
    private readonly cache: CacheObjectService<any>,
    public readonly device: DeviceService) {
    super(route);
    this.device.hide();
  }

  public ngOnInit() {
    this.route.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState)
          this.artistService.isBackFromItem = true;
      });
      this._locationObserve = this.location.subscribe(c => {
        this.initialing();
      });
    this.router.params.subscribe(a => {
      this.id = a.id;
      this.cache.getObjectCache(`/api/artist/${a.id}`).subscribe(c => {
        const _shorDesc = c['bio'] ? c['bio'].replace(new RegExp(/<[^>]*>/, "gm"), "") : '';
        this.model = {
          artistType: c['artistType'],
          bio: c['bio'],
          literature: [],
          image: c['artistId'],
          shortDesc: _shorDesc.length > 300 ? _shorDesc.substring(0, 299) : _shorDesc,
          title: c['firstName'] + ' ' + c['lastName'],
          totalBook: c['totalBooks'],
          totalTimes: c['totalTime'],
          recordVersion: c['recordVersion']
        };
      })
      this.artistId = a.id;
      this.loadingDataNext();
      this.indicator.hide();
    })
  }

  public setBackground(image, recordVersion) {
    return `url(${environment.imageUrl}/content/artists/${image}/pic.jpg?w=512&h=512&t=${recordVersion})`
  }

  public showDescription() {
    this.addModalOpenedToUrl();
    this.isShowDescription = true;
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
    this.chkd.detectChanges();
  }

  public closeDescPopup(e) {
    this.onBackKeyButton(() => this.isShowDescription = e);
  }
  public onBackKeyButton(callback?: () => {}) {
    if (this.location.path(true).includes('#modalOpened')) {
      this.location.back();
    }
    else
      this.initialing();

    if (callback)
      callback();
  }

  private initialing() {
    this.isShowDescription = false;
    this.render.removeStyle(this.document.body, 'overflow');
    this.chkd.markForCheck();
  }

  private addModalOpenedToUrl() {
    this.platformLocation.pushState(null, null, this.location.path() + '#modalOpened');
  }

  private async loadingDataNext() {
    const url = `/api/audiobooks/artist/${this.artistId}?$inlinecount=allpages&$skip=${this.page * this.PAGE_SIZE}&$top=${this.PAGE_SIZE}`;
    this.isLoading = true;
    await this.cache.getObjectCacheOfList(url, `audiobooks/artist/${this.artistId}`, this.page).pipe(
      map((res) => {
        this.isLoading = false;
        this.isEnd = (res.items.length === res.total);
        this.books = res.items;
        this.indicator.hide();
        this.indicator.hideHude();
        this.chkd.detectChanges();
      })
    ).toPromise();
    if (this.artistService.isBackFromItem)
      super.scrollToPosition();
  }

  public goToPage(page: number) {
    this.page = page;
    this.artistService.isBackFromItem = false;
    this.loadingDataNext();
  }

  public ngOnDestroy() {
    this.indicator.hideHude();
    if (this._locationObserve)
    this._locationObserve.unsubscribe();
  }
}
